<h2 mat-dialog-title *ngIf="variety.id === undefined">Create Variety</h2>
<h2 mat-dialog-title *ngIf="variety.id !== undefined">Edit Variety for {{variety.name}}</h2>

<mat-dialog-content class="mat-typography">
  <form (ngSubmit)="onSubmit()" id="varietyForm" #varietyForm="ngForm" class="container-fluid px-0" [nbSpinner]="cropLoading">
    <div class="row">
      <div class="col-md-4">
        <mat-form-field class="d-block w-100" appearance="outline">
          <mat-label>Name</mat-label>
          <input type="text" matInput id="name" name="name" [(ngModel)]="variety.name"
            [value]="variety.name" required #name="ngModel">
        </mat-form-field>
      </div>

      <div class="col-md-4">
        <mat-form-field class="d-block w-100" appearance="outline">
          <mat-label>Short Code</mat-label>
          <input type="text" matInput id="shortCode" name="shortCode" [(ngModel)]="variety.varietyShortName" [value]="variety.varietyShortName" #shortCode="ngModel">
        </mat-form-field>
      </div>

      <div class="col-md-4">
        <mat-form-field class="d-block w-100" appearance="outline">
          <mat-label>Integration Name</mat-label>
          <input type="text" matInput id="integrationId" name="integrationId"
            [(ngModel)]="variety.integrationId" [value]="variety.integrationId"
            #integrationId="ngModel">
        </mat-form-field>
      </div>

      <div class="col-md-4">
        <mat-form-field class="d-block w-100" appearance="outline">
          <mat-label>
            Crop
          </mat-label>
          <mat-select name="cropDropdown" id="cropDropdown" [(ngModel)]="variety.cropId"
            (selectionChange)="onCropChange($event.value)" required #cropDropdown="ngModel">
            <mat-option>(SELECT)</mat-option>
            <mat-option *ngFor="let v of this.crops" [value]="v.id">
              {{v.name}}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <div class="col-md-4" *ngIf="this.categories.length > 0">
        <mat-form-field class="d-block w-100" appearance="outline">
          <mat-label>
            Category
          </mat-label>
          <mat-select name="categoryDropdown" id="categoryDropdown"
            [(ngModel)]="variety.categoryId" #categoryDropdown="ngModel">
            <mat-option>(SELECT)</mat-option>
            <mat-option *ngFor="let v of this.categories" [value]="v.id">
              {{ (v.designator ? v.designator + ' - ' : '') }}{{v.name}}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <div class="col-md-4">
        <div class="d-flex align-items-center gap-2">
          <mat-form-field class="d-block w-100" appearance="outline">
            <mat-label>Color</mat-label>
            <input type="text" matInput id="color" name="color" [(ngModel)]="variety.uiColor" [value]="variety?.uiColor" #color="ngModel" cpAppendTo="body"  [cpPosition]="'bottom right'"
              [(colorPicker)]="variety.uiColor" (cpToggleChange)="onColorPickerToggle($event)">
          </mat-form-field>
          <div class="color-dot-wrap">
            <span class="dot" [ngStyle]="{ 'background-color' : variety?.uiColor}"></span>
          </div>
        </div>
      </div>

      <div class="col-md-4 checkbox-cell">
        <mat-checkbox color="primary" placeholder="Organic" name="organicCheckbox" id="organicCheckbox"
          [(ngModel)]="variety.isOrganic" [(value)]="variety.isOrganic"
          #organicCheckbox="ngModel">Organic</mat-checkbox>
      </div>

      <div class="col-md-4 checkbox-cell">
        <mat-checkbox color="primary" placeholder="Active" name="active" id="active" [(ngModel)]="variety.isActive"
          [(value)]="variety.isActive" #active="ngModel">Active</mat-checkbox>
      </div>

      <div class="col-md-4" *ngIf="showRecheckInterval">
        <mat-form-field class="d-block w-100" appearance="outline">
          <mat-label>Recheck Interval</mat-label>
          <input type="number" matInput class="row" id="recheckInterval" name="recheckInterval"
            [(ngModel)]="variety.recheckInterval"
            [value]="variety.recheckInterval" min="0" #recheckInterval="ngModel">
        </mat-form-field>
      </div>
    </div>

    <hr *ngIf="isEditBtnClick" style="width: 100%;" />

    <!-- Custom Fields -->
     <div [ngClass]="{'color-picker-open': isColorPickerOpen}">
       <h2 *ngIf="isEditBtnClick" mat-dialog-title>Custom Fields</h2>
       <div *ngIf="isEditBtnClick">
         <!-- Custom Fields -->
         <div class="row" *ngFor="let item of variety.customFields">
           <div class="col-md-4">
             <mat-form-field class="d-block w-100" appearance="outline">
               <!-- Use ngModelOptions with standalone: true -->
               <mat-label>Name</mat-label>
               <input type="text" matInput [id]="item.name" [(ngModel)]="item.name" [ngModelOptions]="{standalone: true}">
             </mat-form-field>
           </div>
           <div class="col-md-4">
             <mat-form-field class="d-block w-100" appearance="outline">
               <mat-label>Value</mat-label>
               <textarea matInput rows="1" [id]="item.value" [(ngModel)]="item.value" [ngModelOptions]="{standalone: true}"></textarea>
             </mat-form-field>
           </div>
           <div class="col-md-4">
             <div class="d-flex">
               <mat-form-field class="d-block w-100" appearance="outline">
                 <mat-label>Type</mat-label>
                 <mat-select [(ngModel)]="item.type" [ngModelOptions]="{standalone: true}">
                   <mat-option value="detail-description">Detail</mat-option>
                   <mat-option value="Main">Main</mat-option>
                 </mat-select>
               </mat-form-field>
               <button type="button" (click)="confirmDelete(item.id)" class="btn btn-sm btn-active-danger btn-icon-hover">
                 <fa-icon style="cursor: pointer;" [icon]="faTrash"></fa-icon>
               </button>
             </div>
           </div>
         </div>
   
   
         <!-- Add Customer Field -->
         <div class="row">
           <div class="col-md-4" *ngIf="this.variety.id != 0">
             <mat-form-field class="d-block w-100" appearance="outline">
               <mat-label>Name</mat-label>
               <input type="text" matInput id="newName" name="newName" [(ngModel)]="newCustomField.name"
                 #newName="ngModel">
             </mat-form-field>
           </div>
           <div class="col-md-4">
             <mat-form-field class="d-block w-100" appearance="outline">
               <mat-label>Value</mat-label>
               <textarea matInput rows="1" id="value" name="value" [(ngModel)]="newCustomField.value"
                 #value="ngModel">
             </textarea>
             </mat-form-field>
           </div>
           <div class="col-md-4">
             <mat-form-field class="d-block w-100" appearance="outline">
               <mat-label>Type</mat-label>
               <mat-select name="type" id="type" [(ngModel)]="newCustomField.type" #[item.id]="ngModel">
                 <mat-option value="detail-description">Detail</mat-option>
                 <mat-option value="Main">Main</mat-option>
               </mat-select>
             </mat-form-field>
           </div>
         </div>
         <div class="d-flex justify-content-end mb-2">
           <button [disabled]="!newCustomField.name || !newCustomField.value || !newCustomField.type" type="button"
             mat-raised-button color="primary" (click)="addCustomField()">
             <fa-icon style="cursor: pointer;" class="me-2" [icon]="faPlus"></fa-icon>
             Add Field
           </button>
         </div>
       </div>
     </div>
  </form>
</mat-dialog-content>

<mat-dialog-actions class="pb-0">
  <div class="custom-dialog-actions">
    <div class="btn-group me-2">
      <button *ngIf="!submitting" type="submit" [disabled]="!varietyForm.valid" id="submitButton" data-testid="variety-save-button" form="varietyForm"
          class="custom-button save-button"><span class="fa-icon-wrapper"><i class="fas fa-save"></i></span>Save</button>
      <mat-spinner *ngIf="submitting" [diameter]="20"></mat-spinner>
      <button data-testid="variety-cancel-button" (click)="cancelClicked(false)" class=" custom-button cancel-button">
        <span class="fa-icon-wrapper"><i class="fas fa-times"></i></span>Cancel
      </button>
    </div>
  </div>
</mat-dialog-actions>